export default {
  title: 'Branduri',
  form: {
    name: {
      placeholder: 'Caută brand...',
    },
  },
  fields: {
    id: '#',
    name: 'Nume',
    address: 'Adresă',
    subdomain: 'Subdomeniu',
    shop_url: 'URL magazin',
    companies: 'Companii',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'Niciun brand încă',
  modals: {
    delete_franchise: {
      title: 'Sigur doriți să ștergeți brandul {{name}}?',
    },
  },
  buttons: {
    new_franchise: '+ Adaugă brand',
    export_restaurants: 'Exportă restaurante',
    edit: 'Editează',
    delete: 'Șterge',
    view_dashboard_as_owner: 'Vezi tabloul de bord ca proprietar',
    open_shop: 'Deschideți magazinul',
  },
  toasts: {
    failed_to_load_data: 'Datele nu au putut fi încărcate',
    failed_to_delete_franchise: 'Ștergerea brandului a eșuat',
    franchise_got_deleted: 'Brandul a fost șters',
    failed_to_create_magic_link: 'Linkul magic nu a putut fi creat',
    no_owner_to_log_in_as: 'Niciun proprietar de restaurant ca utilizator pentru autentificare',
  },
};
